import { Component } from '@angular/core';

@Component({
    selector: 'app-negociacao-coletiva-completa-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura.component.html',
    styleUrls: ['./bloqueio-assinatura.component.css']
})

export class NegociacaoColetivaCompletaBloqueioAssinaturaComponent {
}
